import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import ModifyTravelRow from './ModifyTravelRow'
import ViewTravelRow from './ViewTravelRow'
import { TravelMutationDto, TravelOverviewDto } from '../../../config/registrationConfig'
import RegistrationList, { registrationListColumns, RegistrationListProps } from '../Registration/RegistrationList'
import * as Yup from 'yup'
import { IColumn } from '@fluentui/react'
import { useTranslation } from 'react-i18next'

export type TravelListProps = RegistrationListProps<TravelOverviewDto>

const getColumns = (translate: (key: string) => string): IColumn[] => [
    registrationListColumns.user(),
    registrationListColumns.date(),
    registrationListColumns.description(translate),
    {
        key: 'distance',
        fieldName: 'distance',
        name: translate('base.table.header.distance'),
        minWidth: 64,
    },
    registrationListColumns.price('rate', translate('base.table.header.rate'), false),
    registrationListColumns.price('subtotal', translate('base.table.header.subtotal'), true),
    registrationListColumns.invoice(translate),
    registrationListColumns.actions(),
]

const getValidationSchema = (translate: (key: string) => string): any =>
    Yup.object().shape({
        date: Yup.string().trim().required(translate('file.pivot.registration.travel.form.date.empty')),
        description: Yup.string().trim().required(translate('file.pivot.registration.travel.form.description.empty')),
        distance: Yup.string().trim().required(translate('file.pivot.registration.travel.form.distance.empty')),
    })

export default function TravelList(props: TravelListProps): ReactElement {
    const { t: translate } = useTranslation()
    const columns = useMemo(() => getColumns(translate), [])

    return (
        <RegistrationList<TravelOverviewDto, TravelMutationDto>
            detailsListProps={{ columns }}
            {...props}
            baseUrl="/registration/travel"
            initialValues={{ rate: '0.23', distance: '' }}
            mapItem={(item: TravelOverviewDto) => ({ distance: item.distance })}
            viewRow={ViewTravelRow}
            modifyRow={ModifyTravelRow}
            validationSchema={getValidationSchema(translate)}
        />
    )
}
